/* ---------- on scroll function js start here  ---------- */
$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight() / 2;
    var viewportTop = $(window).scrollTop();
    var viewportHalf = viewportTop + $(window).height() / 2;
    return elementBottom > viewportTop && elementTop < viewportHalf;
  };
  /* ---------- on scroll function js start here  ---------- */
  
  
  jQuery(document).ready(function () {
    
  // if($('.desktop_product_instagram .fs-timeline').html() == ''){
  //   $('.as_seen_more_section').hide();
  // }
    setTimeout(function() {
      if($('.desktop_product_instagram .fs-entry-container').length == 0)
      {
        $('.template-product .as_seen_more_section').hide();
      }
    },1000);
  
  
    // $(window).on('scroll', function() {
    //   $('.top_filter_menu').addClass('fixed-filter');
    // });
  
    
    // $maxHeight = 0;
    // $(".common_div").each(function(){
    //   if($(this).height() > $maxHeight) {
    //     $maxHeight = $(this).height();
    //   }
    // });
    // $(".common_div").height($maxHeight);
    
    //--------- home page slider only ---------//
    $(window).on('load resize orientationchange', function () {
      if($('.hh_page').find('.common_div').length > 1){
        $('.hh_page').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          autoplay: true,
          pauseOnFocus: false,
          pauseOnHover: false,
          pauseOnDotsHover: false,
          autoplaySpeed: 4000,
          mobileFirst: true,
          infinite: true,
          dots: true,
          arrows: false
        });
      } else if($('.hh_page').find('.common_div').length == 1){
        $('.hh_page').addClass("hh-length");
      }
    });
    //--------- End home page slider only ---------//
  
    // --------- START TOP HEADER FIXED --------- // 
    // $(window).scroll(function () {
    //   var scroll = $(window).scrollTop();
    //     if (scroll >= 300) {
    //       $(".header_style_one").addClass("add_fixed_header");
    //       $(".announcement-bar").slideUp();
    //     } else {
    //        $(".header_style_one").removeClass("add_fixed_header");
    //        $(".announcement-bar").slideDown();
    //     }
    // });
    
  
    if($('body.journal_single_page').hasClass('white')){
      $('body.journal_single_page').removeClass('white');
    }else if($('body.collaboration-single').hasClass('white')){
      $('body.collaboration-single').removeClass('white');
    }
  
    //  I have addedd this script for PDP Page  =======================
   $('body').on('click', '.pdp_bottom_btn', function(e) {
      e.preventDefault();
      if($('body').attr('data-actiview') == 'face_pared'){
        $('body').attr('data-actiview', 'product_gallery');
        $('body').removeClass('pdp_main_gallery');
        var url = $(this).parents('.pdp_wrapper').data('phandel');
        $.get('/products/' + url, function(data) {          
          var append = $(data).find(".pdp_wrapper").html();
          $(".pdp_wrapper").html(append); 
          $(".price__show").show();
          if($('.add_to_cart_info').attr('data-available') == 'true'){
            $('.add_to_cart_info').show();
            $('.pdp_info').show();
            window.Shopify.PaymentButton.init();
          }
           if ($('.pdp_main_slider').hasClass('slick-initialized')) {
             $('.pdp_main_slider').slick('unslick');
           }
          $('.pdp_main_slider').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              fade: true,
              infinite: true,
              adaptiveHeight: true,
              asNavFor: '.pdp_thumb_slider',
              responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    dots: true
                  }
                }
              ]
            });
          $('.pdp_thumb_slider').slick({
              slidesToShow: 3,
              slidesToScroll: 1,
              asNavFor: '.pdp_main_slider',
              dots: false,
              arrows: true,
              infinite: true,
              focusOnSelect: true,
              responsive: [
                {
                  breakpoint: 1025,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  }
                }
              ]
            });           
          document.dispatchEvent(new CustomEvent("swym:collections-loaded")); 
          console.log(BIS,'BISBIS');
           if(typeof BIS != 'undefined'){
            if (BIS.urlIsProductPage() === true) {
              BISPopover.ready.then(function() {
                // Exit script if product has no sold out variants.
                if (BIS.popup.variants.length < 1) {
                  return;
                }
                // Build and style the Back in Stock button or link
                // that will be inserted into the product page.
                var button = document.createElement('button');
                button.setAttribute('id', 'BIS_trigger');
                button.setAttribute('class', 'btn');
                button.style.cssText = 'margin-top: 5px'
                button.textContent = BIS.Config.button.caption;
                // Insert the button into the product page.
                BIS.inlineButtonAnchor = 'form[action ^= "/cart/add"]';
                var anchor = document.querySelectorAll(BIS.inlineButtonAnchor)[0];
                anchor.insertAdjacentElement('beforeend', button);
                // Control button visibility
                var variantId;
                BIS.refreshInlineButton = function() {
                  try {
                    var variant = BIS.detectVariant(BIS.popup);
                    if (variant && BIS.popup.variantIsUnavailable(variant)) {
                      variantId = variant.id;
                      button.style.display = '';
                    } else {
                      button.style.display = 'none';
                    }
                  } catch (e) {
                    console.log(e);
                  }
                };
                setTimeout(BIS.refreshInlineButton, 15);
                button.addEventListener('click', function() {
                  BIS.popup.form.selectVariant(variantId);
                });
                document.addEventListener('change', function() {
                  setTimeout(BIS.refreshInlineButton, 15);
                });
              });
            }
           }          
        });
      }else{
        $('body').attr('data-actiview', 'face_pared');
        $('body').addClass('pdp_main_gallery');
        var url = $(this).parents('.pdp_wrapper').data('phandel');
        $.get('/products/' + url + '?view=gallery', function(data) {
          var append_as = $(data).find(".pdp_wrapper").html();
          $(".pdp_wrapper").html(append_as);
          if($('.add_to_cart_info').attr('data-available') == 'true'){
            $('.add_to_cart_info').show();
            $('.pdp_info').show();
            window.Shopify.PaymentButton.init();                  
          }
        });
      }
    });
  
    //    I have addedd this script for PDP Page   =======================
   
    // ----- START CART JS ---- //
    $('.right_mobile_menu > .cart_button_main > a, .cart_list_header').click(function () {
      $(".main_cart_body").addClass("active_cart_body");
      $("body").addClass("overflow-hidden");
      $(".over_layer").addClass("activer_layer");
    });
    $('.over_layer, closecart').click(function () {
      $(".main_cart_body").removeClass("active_cart_body");
      $("body").removeClass("overflow-hidden");
      $(".over_layer").removeClass("activer_layer");  
      $(".top_category_menu").removeClass("active_filter");
      $(".over_layer").removeClass('activer_layer');
      $("body").removeClass('overflow-hidden');
    }); 
    $('.overlay_search, closecart, .close_search').click(function () {
      $(".main_search_box").removeClass("active_cart_body");
      $("body").removeClass("overflow-hidden");
      $(".overlay_search").removeClass("activer_layer");
      $(".main_search_box").removeClass('active_search');
    });
    // -----  END CART JS  ---- //
  
    // ----- START POPUP OPEN ---- //
    $(".close_popup_icon > button").click(function () {
      $(".main_home_popup").addClass("remove_popup")
    });
    // ----- END POPUP OPEN ---- //
  
    // ----- START MOBILE  MENU ---- //
    $("body").on('click','.mobile_menu_icon',function () {
      $(".mobile_menu_icon").toggleClass("closed_mobile_menu");
      $(".mobile_menu_bar").toggleClass("active_mobile_menu");
      $("body").toggleClass("overflow-hidden");
    });   
    // ----- END MOBILE  MENU ---- //
  
    // ------- START MOBILE MENU INNER  ------- //
    $('body').on('click','.acnav__label',function () { 
      $(this).closest('.mobile_menu_list').find(".has-children").removeClass("is-open");
      $(this).closest('.mobile_menu_list').find(".acnav__list").slideUp();
      if (!$(this).next().is(":visible")) {      
        $(this).next().slideDown();
        $(this).closest('.has-children').addClass("is-open");
      }
    }); 
    // ------- END MOBILE MENU INNER  ------- //
   
    // ------- START   ------- // 
    // -------- START SECOUND PRODUCT ROW  --------// 
    
    jQuery('.product_row').slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 375,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    }); 
    var $wrapperSlider = $('.product_row'),
    wrapperSlider = $wrapperSlider[0];
    if ($(window).width() > 768){
    $('.product_images').on('mousedown', function(){
      wrapperSlider.slick.setOption({
        swipe: false
      })
    }) 
    $('.product_images').slick({
      dots: false,
      infinite: false,
      arrows: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    })
    .on('afterChange', function(event, slick){
      wrapperSlider.slick.setOption({
        swipe: true
      })
    }); 
  }
    // -------- END SECOUND PRODUCT ROW  --------//
  
    // -------- START PDP SIZE POPUP -------- //
    $(".pdp_size").click(function(){
      $(".fancybox-overlay").addClass("active_fancybox");
      $("body").addClass('overflow-hidden');
    }); 
    $(".close_button_pdp").click(function(e){
      $(".fancybox-overlay").removeClass("active_fancybox");
      $("body").removeClass('overflow-hidden');
      return false;
    });
    // --------  END PDP SIZE POPUP  -------- //
   
    // --------  START FILTER MENU  --------//
    $(".filter-lable").click(function() {
      $(".filter-lable").removeClass("active");
      $(".filter-inner").slideUp();
      if (!$(this).next().is(":visible")) {
        $(this).next().slideDown();
        $(this).addClass("active");
      }
    })
    $(".filter-var-lable").click(function() {
      $(".filter-var-lable").removeClass("active");
      $(".filter-var ul").slideUp();
      if (!$(this).next().is(":visible")) {
        $(this).next().slideDown();
        $(this).addClass("active");
      }
    });
    // --------  END FILTER MENU  --------//
  
    // --------- START ANNOUNCEMENT BAR --------- // 
    $(function () {
      $('.marqee_slider_one').infiniteslide({
        clone: 2,
        speed: 40,
        pauseonhover: false,
      });
    });

    
    // --------- END ANNOUNCEMENT BAR --------- // 
  
    // --------- START CLASSICS PRODUCT SLIDER --------- //
    $('.inner_classics').slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
    // --------- END CLASSICS PRODUCT SLIDER --------- //
  
    // --------- START BLOG SLIDER --------- //
    const init = {
      autoplay: false,
      infinite: true,
      cssEase: "linear",
      slidesToShow: 2,
      arrows: false,
      dots: false,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    $(() => {
      const win = $(window);
      const slider = $(".blog_slider");
      win.on("load resize", () => {
        if (win.width() < 769) {
          slider.not(".slick-initialized").slick(init);
        } else if (slider.hasClass("slick-initialized")) {
          slider.slick("unslick");
        }
      });
    });
    // --------- END BLOG SLIDER --------- //
  
    
    // --------- START SEARCH --------- //
    $(".multiple_product_row").click(function(){ 
    $(".single_product_row").removeClass('active_default_product');
    $(this).addClass('active_default_product');
    $(".collection_wrapper").addClass("multiple_products");
    $(".single_product_row").removeClass("single_product_active");
      $('.collection_images_slider').each(function(i, v) {
        if($(this).hasClass('slick-initialized')){
          $(this).slick('refresh');
        }
      });
      $('.top_img_items').each(function(i, v) {
        if($(this).hasClass('slick-initialized')){
          $(this).slick('refresh');
        }
      });
    });
    $(".single_product_row").click(function(){ 
      $(".multiple_product_row").removeClass('active_default_product');
      $(this).addClass('active_default_product');
      $(".collection_wrapper").removeClass("multiple_products");
      $(".single_product_row").addClass("single_product_active");
      $('.collection_images_slider').each(function(i, v) {
        if($(this).hasClass('slick-initialized')){
          $(this).slick('refresh');
        }
      });
      $('.top_img_items').each(function(i, v) {
        if($(this).hasClass('slick-initialized')){
          $(this).slick('refresh');
        }
      });
    });
    
    $(".desk_list_view").click(function(){
      $(this).addClass('desk_product_view_underline');
      $('.desk_product_view').removeClass('desk_product_view_underline')
      $(".collection_wrapper").addClass("collection_wrapper_lifetime"); 
      $(".collection_wrapper").removeClass("active_default_list_view"); 
    });
    $(".desk_product_view").click(function(){
      $('.desk_list_view').removeClass('desk_product_view_underline');
      $(this).addClass('desk_product_view_underline');
      $(".collection_wrapper").addClass("active_default_list_view"); 
      $(".collection_wrapper").removeClass("collection_wrapper_lifetime"); 
    });
    // --------- END SEARCH --------- //
  
    
    // ------------ START COLLECTION IMAGES SLIDER ------------ // 
    $(".multiple_product_row").click(function(){ 
    $(".single_product_row").removeClass('active_default_product');
    $(this).addClass('active_default_product');
    $(".custom_collection").addClass("multiple_products");
    $(".single_product_row").removeClass("single_product_active");
      $('.collection_images_slider').each(function(i, v) {
        if($(this).hasClass('slick-initialized')){
          $(this).slick('refresh');
        }
      });
      $('.top_img_items').each(function(i, v) {
        if($(this).hasClass('slick-initialized')){
          $(this).slick('refresh');
        }
      });
    });
    $(".single_product_row").click(function(){ 
      $(".multiple_product_row").removeClass('active_default_product');
      $(this).addClass('active_default_product');
      $(".custom_collection").removeClass("multiple_products");
      $(".single_product_row").addClass("single_product_active");
      $('.collection_images_slider').each(function(i, v) {
        if($(this).hasClass('slick-initialized')){
          $(this).slick('refresh');
        }
      });
      $('.top_img_items').each(function(i, v) {
        if($(this).hasClass('slick-initialized')){
          $(this).slick('refresh');
        }
      });
    });
    
     
    $(".desk_list_view").click(function(){
      $(this).addClass('desk_product_view_underline');
      $('.desk_product_view').removeClass('desk_product_view_underline')
      $(".custom_collection").addClass("collection_wrapper_lifetime"); 
      $(".custom_collection").removeClass("active_default_list_view"); 
    });
    $(".desk_product_view").click(function(){
      $('.desk_list_view').removeClass('desk_product_view_underline');
      $(this).addClass('desk_product_view_underline');
      $(".custom_collection").addClass("active_default_list_view"); 
      $(".custom_collection").removeClass("collection_wrapper_lifetime"); 
    });
    
     
    // $('.collection_images_slider').each(function(i, v) {
    //   if($(this).find('.inner_main_img').length > 1){
    //     $(this).slick({
    //       dots: true,
    //       infinite: false,
    //       arrows:false,
    //       speed: 300,
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //       responsive: [
    //         {
    //           breakpoint: 768,
    //           settings: {
    //             arrows:true, 
    //           }
    //         }
    //       ]
    //     });
    //   } 
    // }) 
    // ------------  END COLLECTION IMAGES SLIDER  ------------ //
   
    // ------- START SHOP ALL TOP MENU ------- //
    $('body').on('click','.inner_category_menu',function (e) {
      console.log('hihih');
      e.preventDefault();
      var label = $(this);
      var parent = label.parent('.category_menu_listing');
      var list = label.siblings('.drop_down_menu');
      if (parent.hasClass('is-open')) {
        list.slideUp('fast');
        parent.removeClass('is-open');
      } else {
        $('.drop_down_menu').slideUp('fast');
        $('.category_menu_listing').removeClass('is-open')
        list.slideDown('fast');
        parent.addClass('is-open');
      }
    });
    // ------- END SHOP ALL TOP MENU ------- //
  
    // ------- START SHOP ALL TOP MENU ------- //
    $('.inner_drop_down').on('click', function (e) {
      e.preventDefault(); 
      var label = $(this);
      var parent = label.parent('.main_label_filter');
      var list = label.siblings('.category_items_inner_items');
      if (parent.hasClass('is-open')) {
        list.slideUp('fast');
        parent.removeClass('is-open');
      } else {
        $('.category_items_inner_items').slideUp('fast');
        $('.main_label_filter').removeClass('is-open')
        list.slideDown('fast');
        parent.addClass('is-open');
      }
    });
    // ------- END SHOP ALL TOP MENU ------- //
  
  
    // ------- START SHOP MENU JS --------- //
    $('.pdp_color .pdp_size p').click(function(){
      $(".over_layer").addClass('activer_layer');
      $("body").addClass('overflow-hidden');
    });
    
    $(".filter_collision").click(function(){
      $(".top_category_menu").addClass("active_filter");
      $(".over_layer").addClass('activer_layer');
      $("body").addClass('overflow-hidden');
    });
    $('body').on('click', ".colse_filter, .over_layer", function(){
      $(".top_category_menu").removeClass("active_filter");
      $(".over_layer").removeClass('activer_layer');
      $("body").removeClass('overflow-hidden');
    });
    $(".sort_collision").click(function(){
      $(".top_category_menu").addClass("active_sort_list");
      $(".over_layer").addClass('activer_layer');
      $("body").addClass('overflow-hidden');
    });
    $(".over_layer, .colse_sort_list, .close_button_pdp").click(function(){
      $(".top_category_menu").removeClass("active_sort_list");
      $(".over_layer").removeClass('activer_layer');
      $("body").removeClass('overflow-hidden');
      $(".fancybox-overlay").removeClass('active_fancybox');
    });
    // ------- END SHOP MENU JS --------- //
  
    // ------- START OTHER PAGE JS -------- //
    // -------- accordion --------- //
    $(".set > a").on("click", function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).siblings(".content").slideUp(200);
      } else {
        $(".set > a").removeClass("active");
        $(this).addClass("active");
        $(".content").slideUp(200);
        $(this).siblings(".content").slideDown(200);
      }
    });
    // -------- accordion --------- //
  
    // -------- START PARED IMG SLIDER --------- //
    $('.collaboration_pared_img_slider').slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            arrows: false,
          }
        }
      ]
    });
    // -------- END PARED IMG SLIDER --------- //
  
    // -------- START PHOTOGRAPHY SLIDER --------- //
    $('.Photography_slider').slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true,
      responsive: [{
        breakpoint: 769,
        settings: {
          arrows: false,
        }
      }]
    });
    // --------  END PHOTOGRAPHY SLIDER  --------- //
  
    // --------  START NICE SLIDER  --------- //
  
  
    // --------  END NICE SLIDER  --------- //
  
    // -------- START QUALITY MATERIALS SLIDER  ---------//
    $('.quality-materials-slider').slick({
      infinite: true,
      centerMode: false,
      arrows: false,
      dots: false,
      autoplay: false,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
        breakpoint: 769,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 1
        }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    // -------- START QUALITY MATERIALS SLIDER  ---------// 
    // -------  END OTHER PAGE JS  -------- // 
    
    // ------- START SHOP PAGE JS ------- //
    function addRemoveDiv() {
      var wW = $(window).width();
      if (wW >= 769 ) {
        $('.big_product_row').prevAll(".main_collection_items").wrapAll('<div class="top_box_main"></div>');
        $('.big_product_row').nextAll(".main_collection_items").wrapAll('<div class="bottom_box_main"></div>');
      } else if (wW <= 768 ) {
        $('.main_collection_items').unwrap('.top_box_main');
        $('.main_collection_items').unwrap('.bottom_box_main');
      }
    }
    addRemoveDiv();
    $(window).on('resize ', function() {
      addRemoveDiv();
    })
    // ------- END SHOP PAGE JS ------- //
  
    //------ pdp page start here(Renish(28-06-22)) ------//
    $('.pdp_main_slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      infinite: true,
      adaptiveHeight: true,
      asNavFor: '.pdp_thumb_slider',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            dots: true
          }
        }
      ]
    });
    $('.pdp_thumb_slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.pdp_main_slider',
      dots: false,
      arrows: true,
      infinite: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        }
      ]
    });
    //------ pdp page end here(Renish(28-06-22)) ------//
  
    // -------- START LOOKING SLIDER -------- //
    $(window).on('load resize orientationchange', function () {
      $('.row_looking').each(function () {
        var $stand_top_grid = $(this);
        /* Initializes a slick carousel only on mobile screens */
        // slick on mobile
        if ($(window).width() > 768) {
          if ($stand_top_grid.hasClass('slick-initialized')) {
            $stand_top_grid.slick('unslick');
          }
        }
        else {
          if (!$stand_top_grid.hasClass('slick-initialized')) {
            $stand_top_grid.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              mobileFirst: true,
              infinite: false,
              dots: true,
              arrows: false
            });
          }
        }
      });
    })
    // --------  END LOOKING SLIDER  -------- //
   
    // --------  START CUTSTOMER CARE ----------- // 
    $('.faq-scrollist a[href*="#"]:not([href="#"]):not([href="#show"]):not([href="#hide"])').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top - 150
        }, 300);
        return false;
        document.querySelector(".faq-scrolspy li[data-href*=" + sectionId + "]").classList.add("active_list");
      } else {
            document.querySelector(".faq-scrolspy li[data-href*=" + sectionId + "]").classList.remove("active_list");
         }
      }
    });
    
    $(window).scroll(function() {
      var scrollDistance = $(window).scrollTop() + 150;
      $('.customer_tab_content').each(function(i) {
        if ($(this).position().top <= scrollDistance) {
          $('.faq-scrolspy li.active_list').removeClass('active_list');
          $('.faq-scrolspy li').eq(i).addClass('active_list');
        }
      });
    }).scroll();
  
    var a_customer = $('.faq-scrolspy li.active_list').attr('data-name');
    $('.customer_care_left_col').find('.js-link span').html(a_customer);
  
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll >= 35) {
        $(".customer_care_left_col").addClass("customer_care_sticky");
      } else {
        $(".customer_care_left_col").removeClass("customer_care_sticky");
      }
    });
    // ---------- ADD CLASS ---------- //
    $(".pdp_price_wrap .pdp_insta .insta_desktop p").click(function(e){
      console.log('enterrr');
      $(".instagram_popup").addClass("instagram_popup_open");
      $("body").addClass("overflow-hidden");
      $(".over_layer").addClass("activer_layer");
    });
    $(".close_instagram_popup button, .over_layer").click(function(e){
      $(".instagram_popup").removeClass("instagram_popup_open");
      $("body").removeClass("overflow-hidden");
      $(".over_layer").removeClass("activer_layer");
      return false;
    });
   
    $('body').on('click','.input_group_cart .btn', function(e) {
      e.preventDefault();
      $input = $(this).closest('.input_group_cart').find('.maincart-quantity');
      var oldval = $input.val();
      var newval;
      if($.trim($(this).text()) == "+") {
        newval = parseFloat(oldval)+1;
      }
      else {
        if(oldval > 0) {
          newval = parseFloat(oldval)-1;
        }
        else {
          newval = 0;
        }
      }
      $input.val(newval);
    });
  
    function addToCart() {
      $.get("/cart?view=mini", function(data) {
        $('body').find('#main-cart .main_cart_body').html(data);
      });
    }
  
    function refreshCart() {
      $.getJSON('/cart.js', function(cart){ 
        $('.cart_list_num p').html(cart.item_count);
        $('.cart_shop_num').html('('+cart.item_count+')');
      });
    }
    
    function opencart() {
      $(".main_cart_body").addClass("active_cart_body");
      $("body").addClass("overflow-hidden");
      $(".over_layer").addClass("activer_layer");
    }
  
    function openpopup_loadtime() {
      setTimeout( 
      function() {
        $(".main_cart_body").removeClass("active_cart_body");
        $("body").removeClass("overflow-hidden");
        $(".over_layer").removeClass("activer_layer");
      },3000);
    }
  
    //add-to-cart pdp page
    $('body').on('click', '.pdp_add_to_cart', function(e) {
      e.preventDefault();
      var d = true;
      $('.err-msg').remove();
      var form= $(this).closest('form');
      $.ajax({
        type : 'POST',
        url : '/cart/add.js',
        data : form.serialize(),
        dataType: 'json',
        success : function(data){
          setTimeout( function() {
            addToCart();
            refreshCart();
            opencart();
            openpopup_loadtime();
          },1000);
        },
        error : function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          if($('.err-msg').length > 0)
          {
            $(form).find('.pdp_add_to_cart').after('');
          }else {
            $(form).find('.pdp_add_to_cart').after('<p class="err-msg" style="margin-left:10px;">'+response.description+'</p>').find('.err-msg');
          }
          d= false;
          return false;
        }
      });
    });
  
    //mini-cart remove item
    $('body').on('click', '.cart_remove_item', function(e) {
      e.preventDefault();
      var line_no = $(this).attr('data-line');
      console.log(line_no);
      jQuery.ajax({
        type : 'POST',
        url : '/cart/change.js',
        dataType : 'json',
        data : {
          line: line_no, 
          quantity: 0
        },
        success : function(){
          addToCart();
          refreshCart();
        },
        error: function(){
          console.log('error when removing product from the cart');
        }
      });
    });
  
    //update item on cart page
    $('body').on('click', '.cart_inc_dec', function() {
      var qty = $(this).parent('.input_group_cart').find('.maincart-quantity').val();
      var key = $(this).parent('.input_group_cart').find('.maincart-quantity').attr('data-id');
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          id: key,
          quantity: qty
        },
        async: false,
        success : function(){
          $.get('/cart',function(data){
            var html = $(data).find('.main_cart-inner').html();
            $('.main_cart-inner').html(html);
          });
          refreshCart();
        },
        error: function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          alert(response.description);
        }
      });
    });
  
    //remove item on cart page
    $('body').on('click', '.cart_item', function(e) {
      e.preventDefault();
      var line_no = $(this).attr('data-index');
      jQuery.ajax({
        type : 'POST',
        url : '/cart/change.js',
        dataType : 'json',
        data : {
          line: line_no, 
          quantity: 0
        },
        success : function(){
          $.get('/cart',function(data){
            var html = $(data).find('.main_cart-inner').html();
            $('.main_cart-inner').html(html);
          });
          refreshCart();
        },
        error : function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          alert(response.description);
        }
      });
    });
  
    // if($('.smooth_scoll').length){
    //   if($(window).width() > 768){
    //     var delay = false;
    //     var currentPage = 1;
    //     var pageCount = $(".smooth_scoll_section").length;
    //     var swipe = document.getElementsByTagName('.smooth_scoll_section');
    //     $(document).on('mousewheel DOMMouseScroll', function(event) {
    //       event.preventDefault();
    //       if (delay) return;
    //       delay = true;
    //       setTimeout(function() { delay = false }, 800)
    //       var wd = event.originalEvent.wheelDelta || -event.originalEvent.detail;
    //       if (wd < 0) {
    //           if (currentPage < pageCount) {
    //               currentPage++;
    //           }
    //       } else {
    //           if (1 < currentPage) {
    //               currentPage--;
    //           }
    //       }
    //       $('html,body').animate({
    //           scrollTop: $('#sec' + currentPage).offset().top - $('#shopify-section-header .main_header_list').height()
    //       }, 100);
    //       $('#sec' + currentPage).addClass('active');
    //       for (var i = 1; i <= pageCount; i++) {
    //           if (i != currentPage) {
    //               $('#sec' + i).removeClass('active');
    //           }
    //       }
    //     });
    //   }
    // }
  
    /* ---------- on scroll js start here  ---------- */
    $(window).on('resize scroll', function() {
      $('section.white').each(function() {
        if ($('section.white').hasClass('inview')){
          $("body").addClass("white");
        }
        else{
          $("body").removeClass("white");
        }
        if ($(this).isInViewport()) {             
          $(this).addClass("inview");
        } else {
          
          $(this).removeClass("inview");
        }
      });
    });
    /*----------  on scroll js end here ---------- */
  
    if(window.matchMedia("(max-width: 768px)").matches){
      var list = $('.js-dropdown-list');
      var link = $('.js-link');
      link.click(function(e) {
        e.preventDefault();
        list.slideToggle(200);
      });
      list.find('li a').click(function() {
        var text = $(this).html();
        var icon = '<svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 8L8.35355 8.35355L8 8.70711L7.64645 8.35355L8 8ZM15.3536 1.35355L8.35355 8.35355L7.64645 7.64645L14.6464 0.646448L15.3536 1.35355ZM7.64645 8.35355L0.646445 1.35356L1.35355 0.646449L8.35355 7.64645L7.64645 8.35355Z" fill="#1E1E1E"/></svg>';
        link.html(text+icon);
        list.slideToggle(200);
      });
    } else{}
  
    
    /* ------- sticky product-detail add to cart start here ------- */   
  
    if($('.add_to_cart_info').length != 0){
      var ssd_s = $('.add_to_cart_info').offset().top + 150;
    console.log(ssd_s, ">>>>>");
      let startShow = ssd_s + $(window).height()/2;
      $(window).scroll(function(){
        if($(window).width() <= 749){
          if( $(window).scrollTop() > startShow) { 
            $('.sticky_add_to_cart').show(300)
            $('.sticky_add_to_cart').css('opacity', '1');
            $('.sticky_add_to_cart').css('visibility', 'visible');
            if($(window).scrollTop() == $(document).height()-$(window).height()){ 
              $('.sticky_add_to_cart').hide(300)
            }
          } 
          else if( $(window).scrollTop() <= startShow) { 
            $('.sticky_add_to_cart').hide(300)
          }
          else{ 
            $('.sticky_add_to_cart').hide(300)
          }
        } 
      })
    }
      $.fn.isOnScreen = function() {
        var win = $(window);
        var viewport = {
          top: win.scrollTop(),
          left: win.scrollLeft()
        };
        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();
        var bounds = this.offset();
        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();
        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
      };
   
  
      
    
  });
   
  
  $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      var height = $('.top_filter_menu_banner_filter').height();
      var newHeight = height + 50;
      var newHeight_m = height - 150;
    
        if (scroll >= 150) {
          $(".top_filter_menu").addClass("fixed-filter");
          $(".over_layer").addClass("filter-menu-layer");
           $(".collection_product").addClass("category_filter_fixed");
        } else {
           $(".top_filter_menu").removeClass("fixed-filter");
           $(".over_layer").removeClass("filter-menu-layer");
           $(".collection_product").removeClass("category_filter_fixed");
        }
    console.log(newHeight,"check")
      if (scroll >= newHeight) {
        $(".top_category_filter.top_filter_menu_banner_filter").addClass("fixed-filter-banner");
         $('.top_filter_menu_banner_filter').css('--dynamic-height', `${-newHeight_m}px`);
       
        } else {
         $(".top_category_filter.top_filter_menu_banner_filter").removeClass("fixed-filter-banner");
        }
    });
    

  // if ($(window).width() < 769) {
  //  }
  
  
  $( document ).ready(function() {
    $slickGreen = false;
    function greenSlider() {
      if ($(window).width() < 769) {
          $('.collaboration_landing_page.collaboration-single .col_gallery_row').slick({
              slidesToShow: 5,
              slidesToScroll: 1,
              autoplay: false,
              autoplaySpeed: 2000,
              responsive: [
                  {
                      breakpoint: 9999,
                      settings: "unslick"
                  },
                  {
                      breakpoint: 769,
                      settings: {
                          slidesToShow: 2,
                          slidesToScroll: 1,
                          infinite: false,
                          dots: false
                      }
                  }
              ]
          });
          $slickGreen = true;
      } else {
          if ($slickGreen) {
              $('.collaboration_landing_page.collaboration-single .col_gallery_row').slick('unslick');
              $slickGreen = false;
          }
      }
    }
    $(document).ready(function () {
      greenSlider();
      $('.collaboration_landing_page.collaboration-single .col_gallery_row').slick('unslick');
    });
    $(window).on('resize scroll', function () {
      greenSlider();
   });
  
   //  -------- NEW PAGE ----------- //
   if ($(window).width() < 769) {
      $('.top_img_items').slick({
          dots: false,
        infinite: false,
        arrows:false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll:1,
      });
    }
  
  });

// ------ 25-11-2022 ------- //

$(document).ready(function () {
      if($(window).width() <= 768){
          $('body').on("click",".main_search__mobile  .search_icon,.collction_search",function(e){
          e.preventDefault();
          $(this).closest('.main_search__mobile').find("form").addClass("open_search_mobile");
          });
          $('body').on("click",".main_search__mobile .close_search",function(e){
          e.preventDefault();
          $(this).closest('.main_search__mobile').find("form").removeClass("open_search_mobile");
          });
      }
      if ($(window).width() < 769) {
          $('.worn-by-celebrity .col_gallery_row .inner_gallery_col > a').slick({
            dots: false,
            infinite: false,
            arrows:false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll:1
          });
        } 
  
      /* --- On click scroll-down to footer --- */
  
      $('body').on('click','.sign-up-btn',function(e){
        e.preventDefault();
        
        $('.mobile_menu_icon').removeClass('closed_mobile_menu');
        $('.mobile_menu_bar').removeClass('active_mobile_menu');
        $('body').removeClass('overflow-hidden');
        $('html, body').animate({
          'scrollTop' : $("footer").position().top
        });
      });

    /* --- Gride Wrapping collection page --- */
  
     if ($(window).width() <= 768){
       $('.product-layouts-wrap,.top_box_main,.collection_row').contents().unwrap();
     }
     
});
 $(document).ready (function () { 
$("body").on('click','.faq_title',function () {
    console.log('====+++====');
    $(".faq_title").removeClass("active");
    $(".faq_content").slideUp();
    if (!$(this).next().is(":visible")) {
      $(this).next().slideDown();
      $(this).addClass("active");
    }
  })
})
// 12-12-2022 load more in page
  // $(document).ready (function () {  
  //   $(".worn_celebrity_gallery .gallery_col").slice(0, 20).show();  
  //   $(".load_more.worn-load_more").on("click", function(e){  
  //     e.preventDefault();  
  //     $(".worn_celebrity_gallery .gallery_col:hidden").slice(0, 4).fadeIn("slow");  
  //     if ($(".worn_celebrity_gallery .gallery_col:hidden").length == 0) {  
  //       $(".load_more.worn-load_more").addClass("noContent");  
  //     }  
  //   });  
  // });  
$(document).ready(function () {
  function remove_zoom(){
  if($('.spzgrhsince').length > 0){    
    console.log('innnnnerrrrr');
      $('.template-product .thumb_item .thumb_item_wrap img').removeClass('spzgrhsince');     
  }else{
    setTimeout(function(){
      remove_zoom();
    },300);
  }
 }
remove_zoom();
})